import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";

import MessageToggle from "../messageToogle";
import {
  logo,
  ClockIcon,
  MailIcon,
  PhoneNumIcon,
  TwitterIcon,
  FacebookIcon,
  LinkedinIcon,
  YoutubeIcon,
  UserIcon,
} from "../imagepath";
import styles from "./header.module.css";

const Header = () => {
  const [showNewMessage, setShowNewMessage] = useState(false);

  useEffect(() => {
    document.body?.classList?.remove("menu-opened");
    return () => {
      document.body.className = "";
    };
  }, []);

  const [navbar, setNavbar] = useState(false);

  const openMobileMenu = () => {
    document.body?.classList?.add("menu-opened");
  };
  const hideMobileMenu = () => {
    document.body?.classList?.remove("menu-opened");
  };
  const changeHeaderBackground = () => {
    if (window.scrollY >= 90) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeHeaderBackground);

  return (
    <header className={styles.header_sticky}>
      <MessageToggle
        showMessage={showNewMessage}
        handleClose={() => setShowNewMessage(false)}
      />
      <div>
        <nav className={styles.header_main}>
          <div
            className={`d-flex flex-row align-items-center ${styles.header_top}`}
          >
            <div
              className={`d-flex flex-row justify-content-between ${styles.header_top_left}`}
            >
              <div className="d-flex flex-row justify-content-center align-items-center p-2">
                <div className="d-flex flex-row gap-1 pe-2 align-items-center">
                  <PhoneNumIcon className={`${styles.header__noneOn560}`} />
                  <p
                    className={`text-white h6 m-0 ps-2 ${styles.header__noneOn560}`}
                  >
                    +1 800-381-6794
                  </p>
                </div>
                <div className="d-flex flex-row gap-1 pe-2 align-items-center">
                  <MailIcon className={`${styles.header__noneOn1440}`} />
                  <p
                    className={`text-white h6 m-0 ps-2 ${styles.header__noneOn1440}`}
                    onClick={() => {
                      setShowNewMessage(true);
                    }}
                  >
                    Edu@AngelWatch.org
                  </p>
                </div>
                <Navbar
                  expand="lg"
                  style={{ height: "50px", padding: "0" }}
                  variant="dark"
                >
                  <Container fluid>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse
                      id="navbarScroll"
                      style={{ color: "white" }}
                    >
                      <Nav className="me-auto my-2 my-lg-0" navbarScroll>
                        <Nav.Link
                          href="/home"
                          style={{
                            color: "white",
                            backgroundColor: "#0D5EF4",
                            padding: "4px 8px 8px",
                          }}
                        >
                          Home
                        </Nav.Link>
                        <Nav.Link
                          href="/aboutUs"
                          style={{
                            color: "white",
                            backgroundColor: "#0D5EF4",
                            padding: "4px 8px",
                          }}
                        >
                          About us
                        </Nav.Link>
                        <Nav.Link
                          href="/include"
                          style={{
                            color: "white",
                            backgroundColor: "#0D5EF4",
                            padding: "4px 8px",
                          }}
                        >
                          Included
                        </Nav.Link>
                        <Nav.Link
                          href="/careGiver"
                          style={{
                            color: "white",
                            backgroundColor: "#0D5EF4",
                            padding: "4px 8px",
                          }}
                        >
                          Caregivers
                        </Nav.Link>
                        <Nav.Link
                          href="/testimonial"
                          style={{
                            color: "white",
                            backgroundColor: "#0D5EF4",
                            padding: "4px 8px",
                          }}
                        >
                          Testimonials
                        </Nav.Link>
                        <Nav.Link
                          href="/faq"
                          style={{
                            color: "white",
                            backgroundColor: "#0D5EF4",
                            padding: "4px 8px",
                          }}
                        >
                          FAQs
                        </Nav.Link>
                        <Nav.Link
                          href="/getCertified"
                          style={{
                            color: "white",
                            backgroundColor: "#0D5EF4",
                            padding: "4px 8px",
                          }}
                        >
                          Get Certified
                        </Nav.Link>
                      </Nav>
                    </Navbar.Collapse>
                  </Container>
                </Navbar>
              </div>
            </div>
            <div>
              <Link className="d-flex flex-row ps-2" to="/login">
                <UserIcon />
                <p className="text-white h6 m-0 ps-2">LogIn</p>
                <p className="text-white h6 m-0 ps-2">/</p>
                <p className="text-white h6 m-0 ps-2">Register</p>
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;

/*

<div className="navbar-header">
                            <Link id="mobile_btn" to="/home" onClick={openMobileMenu}>
                                <span className="bar-icon">
                                <span />
                                <span />
                                <span />
                                </span>
                            </Link>
                            <Link to="/home" className="navbar-brand logo">
                                <img src={logo} className="img-fluid" alt="Logo" />
                            </Link>
                        </div>
                        <div className="main-menu-wrapper">
                            <div className="menu-header">
                                <Link to="/home" className="menu-logo">
                                    <img src={logo} className="img-fluid" alt="Logo" />
                                </Link>
                                <Link
                                    id="menu_close"
                                    className="menu-close"
                                    to="/home"
                                    onClick={hideMobileMenu}
                                >
                                    <i className="fas fa-times" />
                                </Link>
                            </div>
                            <ul className="main-nav">
                                <li className="has-submenu active">
                                    <Link
                                        className="submenu"
                                        to="/home"
                                    >
                                        Home
                                    </Link>
                                </li>
                                <li className="login-link">
                                    <Link to="/login">Login / Signup</Link>
                                </li>
                            </ul>
                        </div>
                        <ul className="nav header-navbar-rht">
                            <DarkMode/>
                            <li className="nav-item">
                                <Link className="nav-link header-sign" to="/login">
                                Signin
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link header-login" to="/selectregister">
                                Signup
                                </Link>
                            </li>
                        </ul>

*/
